module.exports = __webpack_public_path__ + "static/protect-assets-0e7731ccc2f9a4e34e0172b91a43bb31.mp4";